<template>
  <div>
    <div class="card-row row" :class="{ infomsg: disabled,ishighlight: isSelected && !disabled, 'alert-list alert-red': errorMessage.length }">
      <Alert size="large" width="auto" :closable="false" v-if="disabled && errorMessage.length">
        <svgicon class="alert-icon mr-5" name="info" width="12" height="12"/>
        <span v-for="error in errorMessage" :key="error">{{error}}</span>
      </Alert>
      <div class="card-row-col card-col wp3">
        <Checkbox v-if="disabled" :disabled="disabled" :value="isSelected" />
        <Checkbox v-else :value="isSelected && !disabled" @change="onChange" />
      </div>
      <!-- <div v-if="disabled && errorMessage.length" class="alertinfo">
        <Alert type="info" trigger="click">
          <ul>
            <li v-for="error in errorMessage"
              :key="error"
              class="el-alert__title is-bold">{{error}}</li>
          </ul>
          <svgicon class="infosvg" name="info" width="14" height="14" :original="true" />
        </Alert>
      </div> -->
      <div class="card-row-col card-col"
        v-for="(column, index) in sectionHeader"
        :class="column.class"
        :key="index"
        @click="onChange">
        <div v-if="getPaymentDetails[column.label]">
          <span v-if="column.label === 'status'" class="status status-icon" :class="getStatusClass()">
            {{getPaymentDetails[column.label]}}
          </span>
          <span v-else-if="column.tooltip">
            <Tooltip class="item" effect="dark" placement="bottom"
              v-if="getPaymentDetails[column.label].tooltipText">
              <div slot="content" class="tooltipcontent">
                {{getPaymentDetails[column.label].tooltipText}}
              </div>
              <button><span>{{getPaymentDetails[column.label].value}}</span></button>
            </Tooltip>
            <span v-else>{{getPaymentDetails[column.label].value}}</span>
          </span>
          <span v-else-if="column.label === 'age'">
            <span :class="getPaymentDetails.agedPayment ? 'text-red' : ''">
              {{getPaymentDetails[column.label]}}
            </span>
          </span>
          <Ellipsis v-else-if="column.truncateOn"
          :text="getPaymentDetails[column.label]"
          :length="column.truncateOn" />
          <span v-else>{{paymentDetails[column.label]}}</span>
          <small v-if="column.subDetail">{{paymentDetails[column.subDetail.label]}}</small>
        </div>
        <span v-else> - </span>
      </div>
      <div class="card-row-col card-col ml-auto">
        <Tooltip class="item" effect="dark" placement="bottom" :open-delay="300">
          <div slot="content" class="tooltipcontent">
            Confirm physical LR is <br/>available to create an Invoice </div>
            <span class="link-action" @click="update">
              <svgicon name="update" width="14" height="14" :original="true" />
              {{ $t('UPDATE_SLIDER') }}
            </span>
        </Tooltip>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable vue/no-side-effects-in-computed-properties */
import { getTransporterCharges, getRouteByDepot } from '@common/lib/payments';
import AppConstant from '@/constants/app';
import { getDateDiff } from '@/lib/Date';
import { mapGetters } from 'vuex';
import { movementMapLowerForConfig, getPaymentTypes, utilizationStatus, movementMapLower, movementType, MultiMonthPaymentConstants } from 'pando-constants';
import moment from 'moment';
import { statusFilters, enabledPayInDispatchStatusFilters } from '@/constants/payments';

export default {
  props: {
    isMultiDrop: {
      type: String,
    },
    payment: {},
    deliveryType: {
      type: Number,
    },
    isSpecialRebateGateIndent: {
      type: String,
    },
    billToPartyId: {
      type: String,
    },
    type: {
      type: Number,
    },
    truck_type: {
      type: String,
    },
    movement: {
      type: Number,
    },
    state: {},
    sectionHeader: {},
    selected: {},
    blockingDueToAgedInvoice: {
      type: Boolean,
    },
    blockingDueToAgedPayments: {
      type: Boolean,
    },
    paymentAgeWindow: {
      type: Number,
    },
    poNumber: {
      type: String,
    },
    parentPayment: {},
    disabledPayments: {
      type: Array,
      default: () => [],
    },
    disabledPaymentsWithDiffLE: {
      type: Array,
      default: () => [],
    },
    paymentDestinationDepot: {},
    indentDate: {
      default: null,
    },
    indentStatus: {
      default: null,
    },
    indentCreatedDate: {
      default: null,
    },
  },
  data() {
    return {
      isOpenUpdate: false,
      paymentDetails: {},
      errorMessage: [],
      movementMapLowerForConfig,
      statusFilters,
      enabledPayInDispatchStatusFilters,
    };
  },
  created() {
    if (this.disabled) {
      this.$emit('markDisabled', this.payment.id, true);
    }
  },
  computed: {
    ...mapGetters({
      currentClientConfig: 'app/currentClientConfig',
    }),
    getPaymentDetails() {
      this.paymentDetails.indentId = this.payment.order_reference;
      this.paymentDetails.indentCreatedDate = this.payment.indent_created_date ? moment(this.payment.indent_created_date).format('DD MMM YYYY') : '';
      let routeDetails = { value: '-' };
      if (this.payment.type !== getPaymentTypes().DEDICATED_TRUCK_WITHOUT_INDENT_PAYMENT) {
        const route = getRouteByDepot(this.payment);
        routeDetails = { value: route.source.concat(' - ', route.destination), tooltipText: route.multidropCities };
      }
      this.paymentDetails.route = routeDetails;
      this.paymentDetails.vehicleName = this.payment.truck_type;
      if (this.payment.delivered_date !== null) {
        const deliveryDate = this.payment.delivered_date;
        this.paymentDetails.age = getDateDiff(moment(), deliveryDate).toString();
        this.paymentDetails.deliveryDate = moment(deliveryDate).format('DD MMM YYYY');
      }
      if (this.paymentAgeWindow) {
        this.paymentDetails.agedPayment = this.paymentDetails.age >= this.paymentAgeWindow;
      }
      this.paymentDetails.status = this.$statusUtil.getMainStatusName(this.payment.status);
      return this.paymentDetails;
    },
    disabled() {
      this.errorMessage = [];
      let forcedisable = false;
      const lrAttachmentsConfig = this.currentClientConfig.payment_settings &&
        this.currentClientConfig.payment_settings.lr_attachment_required;
      if (this.blockingDueToAgedInvoice) {
        forcedisable = true;
      }
      const disableRow = this.blockingDueToAgedPayments && !(this.getPaymentDetails.agedPayment);
      if (disableRow) {
        this.errorMessage.push(this.$getErr('CLEAR_AGED_PAYMENTS'));
        forcedisable = true;
      }
      if (AppConstant.OrderType.OPEN === this.payment.order_type) {
        const isFreightRatePresent = this.payment.consignee_data.some(
          consignee => getTransporterCharges(consignee.charges)
            && getTransporterCharges(consignee.charges).contract_charge,
        );
        if (!isFreightRatePresent) {
          this.errorMessage.push(this.$getErr('FREIGHT_RATE_MISSING'));
          forcedisable = true;
        }
      }
      if (this.payment.status !== this.$statusUtil.getStatusId('cancelled')) {
        if (!(this.payment.all_physical_documents_available &&
        ((lrAttachmentsConfig && lrAttachmentsConfig[movementMapLower[this.payment.movement]])
          ? this.payment.lr_attachment_available :
          true))) {
          this.errorMessage.push(this.$getErr('LR_NOT_AVAILABLE'));
          forcedisable = true;
        }
      }

      if (!forcedisable && this.type === getPaymentTypes().DEDICATED_TRUCK_WITH_INDENT_PAYMENT
        && this.type && this.truck_type
        && !(this.type === this.payment.type && this.truck_type === this.payment.truck_type)) {
        this.errorMessage.push(this.$getErr('DEDICATED_TRUCK_NOT_COMBINE'));
        forcedisable = true;
      } else if (!forcedisable && this.type && !(this.type === this.payment.type)) {
        this.errorMessage.push(this.$getErr('DEDICATED_TRUCK_NOT_COMBINE'));
        forcedisable = true;
      }

      if (!forcedisable && this.deliveryType && this.deliveryType !== this.payment.delivery_type) {
        this.errorMessage.push(this.$getErr('FTL_PTL_NOT_COMBINE'));
        forcedisable = true;
      }
      if (!forcedisable && this.isSpecialRebateGateIndent && (this.isSpecialRebateGateIndent !== this.payment.is_special_rebate_gate_indent)) {
        this.errorMessage.push('Can\'t combine special rebate and non-rebate indents');
        forcedisable = true;
      }
      if (!forcedisable && this.currentClientConfig.payment_settings &&
        this.currentClientConfig.payment_settings.max_indents_for_invoice) {
        const currMovement = this.currentMovement;
        const effectiveMovement = this.movement || currMovement;
        const maxIndentsConfig = this.currentClientConfig.payment_settings.max_indents_for_invoice;
        const restrictedMovements = Object.keys(maxIndentsConfig);
        if (restrictedMovements.includes(this.movementMapLowerForConfig[effectiveMovement])
            || restrictedMovements.includes(this.movementMapLowerForConfig[currMovement])) {
          if (this.movement && this.movement !== currMovement) {
            this.errorMessage.push(this.$getErr('MOVEMENT_NOT_COMBINE'));
            forcedisable = true;
          }
          const count = maxIndentsConfig && maxIndentsConfig[this.movementMapLowerForConfig[effectiveMovement]];
          if (count && count <= this.selected.length && !this.isSelected) {
            const errorMsg = `Limit exceeded. A maximum of ${count} indent${count === 1 ? '' : 's'} can be selected.`;
            this.errorMessage.push(errorMsg);
            forcedisable = true;
          }
        }
      }
      if (this.poNumber && this.poNumber !== this.payment.po_number) {
        this.errorMessage.push(this.$getErr('PO_NOT_COMBINE'));
        forcedisable = true;
      }
      if (this.currentClientConfig.payment_settings.utilization_approval_required
      && this.payment.approval_status !== utilizationStatus.APPROVED) {
        forcedisable = true;
        this.errorMessage.push(this.$getErr('UTILIZATION_CHECK'));
      }

      const autoBillToParty = this.currentClientConfig.payment_settings &&
       this.currentClientConfig.payment_settings.auto_bill_to_party;
      if (autoBillToParty) {
        const isInvalidMovement = (this.movement === movementType.PRIMARY && this.payment.movement !== this.movement) ||
        (this.movement === movementType.SECONDARY && this.payment.movement !== this.movement);
        if (isInvalidMovement) {
          forcedisable = true;
          this.errorMessage.push(this.$getErr('PRIMARY_MOVEMENT_NOT_COMBINE'));
        }
        if (this.payment.movement !== movementType.SECONDARY) {
          const isMultiDropIndentAvailable = this.selected.some(payment => payment.consignee_data.length > 1);
          if (isMultiDropIndentAvailable && this.isMultiDrop !== this.payment.order_reference) {
            forcedisable = true;
            this.errorMessage.push('Can\'t combine Multi drop indents with other indents');
          } else if (!isMultiDropIndentAvailable && this.payment.isMultiDrop && this.selected.length > 0) {
            forcedisable = true;
            this.errorMessage.push('Can\'t combine Multi drop indents with other indents');
          } else if (!isMultiDropIndentAvailable && !this.payment.isMultiDrop
            && this.selected.length > 0 && this.payment.consignee_data[0] && this.payment.consignee_data[0].destination_location_id !== this.paymentDestinationDepot) {
            forcedisable = true;
            this.errorMessage.push(this.$getErr('COMBINE_INDENT_WITH_DIFFERENT_DROPS'));
          }
        }
      }
      if (this.currentClientConfig && this.currentClientConfig.payment_settings
      && this.currentClientConfig.payment_settings.handle_round_trip_return_as_forward) {
        const parentPaymentId = this.parentPayment && this.parentPayment.id;
        if (parentPaymentId && this.disabledPayments.includes(parentPaymentId)) {
          forcedisable = true;
          this.errorMessage.push(`The forward indent ${this.parentPayment.order_reference} is disabled.`);
        }
      }
      if (this.currentClientConfig.payment_settings.restrict_multi_month_payment) {
        const multiMonthConfig = this.currentClientConfig.payment_settings && this.currentClientConfig.payment_settings.restrict_multi_month_payment;
        const date = (multiMonthConfig === MultiMonthPaymentConstants.INDENT_CREATED_DATE) ? this.payment.indent_created_date : this.payment.delivered_date;
        const currentPaymentMonth = date ? moment(date).month() : null;
        const firstIndentMonth = moment(this.indentDate).month();
        if (this.indentDate && (currentPaymentMonth !== firstIndentMonth)) {
          if (multiMonthConfig === MultiMonthPaymentConstants.INDENT_CREATED_DATE) {
            this.errorMessage.push(this.$getErr('INDENT_CREATED_IN_DIFFERENT_MONTH_NOT_COMBINE'));
          } else if (multiMonthConfig === MultiMonthPaymentConstants.INDENT_DELIVERED_DATE) {
            this.errorMessage.push(this.$getErr('INDENT_DELIVERED_IN_DIFFERENT_MONTH_NOT_COMBINE'));
          }
          forcedisable = true;
        }
      }
      if (this.currentClientConfig.payment_settings && this.currentClientConfig.payment_settings.restrict_multi_month_payment) {
        const multiMonthConfig = this.currentClientConfig.payment_settings.restrict_multi_month_payment;
        const date = (multiMonthConfig === MultiMonthPaymentConstants.INDENT_CREATED_DATE) ? this.payment.indent_created_date : this.payment.delivered_date;
        this.paymentDetails.indentDate = date ? moment(date).format('DD MMM YYYY') : '';
      }
      if (this.indentStatus && (this.indentStatus !== this.payment.status)) {
        this.errorMessage.push(this.$getErr('COMBINE_CANCELLED_AND_DELIVERED_INDENTS'));
        forcedisable = true;
      }
      if (this.disabledPaymentsWithDiffLE.includes(this.payment.id)) {
        forcedisable = true;
        this.errorMessage.push(this.$getErr('DIFFERENT_LEGAL_ENTITY'));
      }
      if (!forcedisable && this.$hasFeature('bill_to_party_filter_in_invoice_flow') && this.billToPartyId
      && this.billToPartyId !== this.payment.bill_to_party) {
        this.errorMessage.push(this.$getErr('BILL_TO_PARTY_NOT_COMBINE'));
        forcedisable = true;
      }
      return forcedisable;
    },
    isSelected() {
      return this.selected.findIndex(selected => selected.id === this.payment.id) >= 0;
    },
    currentMovement() {
      let currMovement = this.payment.movement;
      if (this.parentPayment && this.parentPayment.id
         && this.currentClientConfig.payment_settings.handle_round_trip_return_as_forward
         && !this.disabledPayments.includes(this.parentPayment.id)) {
        currMovement = (this.payment.parent_indent && this.payment.parent_indent.movement)
                         || currMovement;
      }
      return currMovement;
    },
  },
  methods: {
    onChange(status) {
      if (!this.disabled) {
        this.$emit('select', {
          id: this.payment.id,
          indent_total_charge: this.payment.indent_total_charge,
          delivery_type: this.payment.delivery_type,
          is_special_rebate_gate_indent: this.payment.is_special_rebate_gate_indent,
          movement: this.currentMovement,
          type: this.payment.type,
          po_number: this.payment.po_number,
          truck_type: this.payment.truck_type,
          consignee_data: this.payment.consignee_data,
          parent_indent: this.payment.parent_indent,
          child_indent_ids: this.payment.child_indent_ids,
          indent_created_date: this.payment.indent_created_date,
          delivered_date: this.payment.delivered_date,
          status: this.payment.status,
          bill_to_party: this.payment.bill_to_party,
          order_reference: this.payment.order_reference }, status);
      }
    },
    getStatusClass() {
      const list = this.currentClientConfig && this.currentClientConfig.payment_in_dispatch_status
    && this.currentClientConfig.payment_in_dispatch_status.enabled === true
        ? this.enabledPayInDispatchStatusFilters
        : this.statusFilters;
      const filter = list.find(status => status.id === this.payment.status);
      return `status-${filter.color}`;
    },
    update() {
      this.$emit('updateIndent');
      this.toggleBodyClass('addClass', 'no-scroll');
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;
      if (addRemoveClass === 'addClass') {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
  },
  watch: {
    disabled(newVal) {
      this.$emit('markDisabled', this.payment.id, newVal);
    },
  },
};
</script>
